<div class="article-container" [routerLink]="'/blog/' + articlePreview.blogId">
  <div class="main-img">
    <img
      [src]="articlePreview.mainPhoto?.url ?? '/assets/images/blog_default_photo_sm.jpg'"
      onerror="this.src='/assets/images/blog_default_photo_sm.jpg';"
      [attr.alt]="articlePreview.mainPhoto?.alt ?? ''"
      data-cy="preview-main-img"
    />
  </div>

  <div class="article-heading" data-cy="blog-article-heading">
    {{ articlePreview.title }}
  </div>
  <div class="article-text">
    {{ previewExcerpt }}
  </div>
  <div class="article-info">
      <svg-icon src="assets/icons/calendar.svg" [svgStyle]="{ 'width.px':19, 'height.px':21 }" svgClass="svg-icon-calendar"></svg-icon>
      <span class="date">{{ articlePreview.publishOn | date:'d. M. y' }}</span>
      <svg-icon src="assets/icons/eye.svg" [svgStyle]="{ 'width.px':40, 'height.px':35 }" svgClass="svg-icon-eye"></svg-icon>
      <span class="seen">{{ articlePreview.readingTime ? articlePreview.readingTime : 0 }} min</span>
  </div>
</div>
